/**
 * @file useIsMobile.js
 * @description Hook returning whether the viewport is at or below the mobile breakpoint.
 */

import { useState, useEffect } from 'react';

export const MOBILE_BREAKPOINT = 786;

export default function useIsMobile(breakpoint = MOBILE_BREAKPOINT) {
    const [isMobile, setIsMobile] = useState(
        typeof window !== 'undefined' && window.innerWidth <= breakpoint,
    );

    useEffect(() => {
        function handleResize() {
            setIsMobile(window.innerWidth <= breakpoint);
        }
        window.addEventListener('resize', handleResize);
        return function cleanup() {
            window.removeEventListener('resize', handleResize);
        };
    }, [breakpoint]);

    return isMobile;
}
